<div class="container">
    <div class="mt-8">

        @if(topItemList.length > 0)
        {
        <h1 class="text-[30px] font-bold font-mulish mb-2">Top Items</h1>
        <div class="bg-white shadow-md rounded-lg ">
            @for (item of topItemList | slice:0:5; track item.id) {
            <a [routerLink]="['/auctions', this.auctionId(), 'items', item.id]">
                <div class="px-3 pt-[19px] h-[108px] flex overflow-visible">
                    <img *ngIf="!item.imageUrl!.includes('item-default.jpg')" [src]="getSafeUri(item.imageUrl)" [alt]="item.name + ' Logo'"
                        class="w-[84px] h-[56px] object-cover rounded-sm shrink-0" />
                    <app-default-image *ngIf="item.imageUrl!.includes('item-default.jpg')" [element]="'topItems'"></app-default-image>
                    <div class="ml-5 flex flex-col w-full  overflow-hidden">
                        <h3 class="text-[20px] leading-[24px] text-[var(--p-info-500)] font-bold font-mulish truncate">
                            {{item.name}}</h3>
                        <div class="flex mt-[12px]">
                            <span class="text-[18px] leading-[22px] text-black font-semibold font-mulish">
                                @if(item.isBiddable){
                                {{item.currentLeadingBid }}
                                }@else if (item.isBuyable) {
                                {{item.buyNowPrice }}
                                }
                            </span>
                            <span class="text-[16px] text-[var(--p-primary-500)] leading-[19px] font-500 font-mulish px-2 truncate">
                                @if (item.isBiddable && item.numberOfBids == 0) {
                                <span>Opening Bid</span>
                                } @else if (item.isBiddable && item.numberOfBids > 0) {
                                <span>Leading Bid</span>
                                } @else if (item.isBuyable) {
                                <span>Buy Now</span>
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div class="px-3">
                    <div class="bg-[#CED4DA] h-0.5 w-full"></div>
                </div>
            </a>
            }
        </div>
        }
    </div>
</div>